<script setup lang="tsx">
import { Status } from "../../context/context";

import IconSuccessFullfillRound from "./IconSuccessFullfillRound.vue";
import IconErrorFullfillRound from "./IconErrorFullfillRound.vue";
import IconInfoFullfillRound from "./IconInfoFullfillRound.vue";
import IconWaitingFullfillRound from "./IconWaitingFullfillRound.vue";

import IconSuccessTransparentRound from "./IconSuccessTransparentRound.vue";
import IconErrorTransparentRound from "./IconErrorTransparentRound.vue";
import IconInfoTransparentRound from "./IconInfoTransparentRound.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {
    IconSuccessFullfillRound,
    IconErrorFullfillRound,
    IconInfoFullfillRound,
    IconWaitingFullfillRound,

    IconSuccessTransparentRound,
    IconErrorTransparentRound,
    IconInfoTransparentRound
  },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    status?: Status;
    mode?: "fullfill" | "transparent";
  }>(),
  {
    status: "success",
    mode: "fullfill"
  }
);
</script>

<template>
  <div
    :style="{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }"
  >
    <IconSuccessFullfillRound
      v-if="props.status == 'success' && props.mode == 'fullfill'"
    ></IconSuccessFullfillRound>
    <IconErrorFullfillRound
      v-if="props.status == 'error' && props.mode == 'fullfill'"
    ></IconErrorFullfillRound>
    <IconInfoFullfillRound
      v-if="props.status == 'info' && props.mode == 'fullfill'"
    ></IconInfoFullfillRound>
    <IconWaitingFullfillRound
      v-if="props.status == 'waiting' && props.mode == 'fullfill'"
    ></IconWaitingFullfillRound>

    <IconSuccessTransparentRound
      v-if="props.status == 'success' && props.mode == 'transparent'"
    ></IconSuccessTransparentRound>
    <IconErrorTransparentRound
      v-if="props.status == 'error' && props.mode == 'transparent'"
    ></IconErrorTransparentRound>
    <IconInfoTransparentRound
      v-if="props.status == 'info' && props.mode == 'transparent'"
    ></IconInfoTransparentRound>
  </div>
</template>
